import React from 'react';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { SidePage, Section } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import Actions from 'scenes/Events/components/Actions';
import { EventFormEdit } from 'scenes/Events/components/EventForm';
import {
  useLoadEventDetails,
  useIsUpdating,
  useSendToAppsFlyer,
} from 'scenes/Events/data';

import GeneralSection from './GeneralSection';
import Metadata from './Metadata';
import { COMMON_EVENT_SOURCE_ID } from '../../constants';

const EventDetails = ({ id, onClose, onExited, open }) => {
  const isUpdating = useIsUpdating();
  const [childComponent, openChildComponent] = useChildComponent();
  const { data, isLoading, isRefetching } = useLoadEventDetails(id);
  const sendToAppsFlyer = useSendToAppsFlyer();

  const handleEdit = () => {
    openChildComponent(EventFormEdit, {
      id,
    });
  };

  const handleSendToAppsFlyer = () => {
    sendToAppsFlyer({
      appId: data?.application?.id,
      eventName: data?.name,
      reasonCode: data?.reasonCode,
    });
  };

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating || isRefetching}
      open={open}
      size={'md'}
    >
      <SidePage.Title
        title={'Event'}
        entityId={id}
        subTitle={data?.name}
      />
      <SidePage.NewBody wrapper={true} dense={true}>
        <SidePage.NewContent withSidebar={true}>
          {!isEmpty(data) ? (
            <Section title={'General'}>
              <GeneralSection data={data} />
            </Section>
          ) : null}
        </SidePage.NewContent>
        <SidePage.Sidebar
          actions={
            data?.sourceId === COMMON_EVENT_SOURCE_ID ? (
              <Actions
                actions={get(data, 'actions')}
                onEdit={handleEdit}
                data={data}
                onSendToAppsFlyer={handleSendToAppsFlyer}
              />
            ) : null
          }
        >
          <Metadata data={data} />
        </SidePage.Sidebar>
        {childComponent}
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default EventDetails;
